var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _stop19, _stop20, _stop21, _stop22, _stop23, _stop24, _stop25, _stop26, _stop27, _stop28, _stop29, _stop30, _stop31, _stop32, _stop33, _stop34, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDiamond(props) {
  var _id11 = useUniqueInlineId();
  var _id10 = useUniqueInlineId();
  var _id9 = useUniqueInlineId();
  var _id8 = useUniqueInlineId();
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.12 300"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 84.91,
    y1: 245.23,
    x2: 100.55,
    y2: 216.89,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4de1ff"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fffb"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 137.94,
    y1: 233.48,
    x2: 241,
    y2: 233.48,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f0d4"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#39d6da"
  })), _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128aeb"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 235.82,
    y1: 102.69,
    x2: 223.44,
    y2: 197.15,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e96cf"
  })), _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4a76e0"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa4bff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 26.22,
    y1: 69.03,
    x2: 137.94,
    y2: 69.03,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a8cdc"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac51fc"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 174.88,
    y1: 96.04,
    x2: 199.63,
    y2: 43.27,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02feb0"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495df5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 45.25,
    y1: 215.76,
    x2: 45.25,
    y2: 91.06,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#55ebff"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#178fe6"
  })), _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1785e9"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id7,
    x1: 94.26,
    y1: 202.24,
    x2: 182.86,
    y2: 106.8,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4de1ff"
  })), _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#36eae6"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffae"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id8,
    x1: 204.28,
    y1: 40.59,
    x2: 68.12,
    y2: 273.17,
    gradientTransform: "matrix(1 0 0 -1 0 302)",
    gradientUnits: "userSpaceOnUse"
  }, _stop19 || (_stop19 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02feb0"
  })), _stop20 || (_stop20 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38d7ff"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id9,
    cx: 697.72,
    cy: 539.13,
    r: 33.38,
    gradientTransform: "matrix(0 .69 .98 0 -460.13 -374.52)",
    gradientUnits: "userSpaceOnUse"
  }, _stop21 || (_stop21 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffffb"
  })), _stop22 || (_stop22 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4de1ff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id10,
    cx: -532.9,
    cy: -325.29,
    r: 33.38,
    gradientTransform: "matrix(.69 0 0 -.98 504.97 -252.09)",
    gradientUnits: "userSpaceOnUse"
  }, _stop23 || (_stop23 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffffb"
  })), _stop24 || (_stop24 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fffffb",
    stopOpacity: 0.88
  })), _stop25 || (_stop25 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fffffd",
    stopOpacity: 0.59
  })), _stop26 || (_stop26 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.12
  })), _stop27 || (_stop27 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id11,
    cx: 98.19,
    cy: -289.69,
    r: 33.38,
    gradientTransform: "matrix(.69 0 0 -.98 139.91 -96.97)",
    gradientUnits: "userSpaceOnUse"
  }, _stop28 || (_stop28 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffffb"
  })), _stop29 || (_stop29 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f0f9fc",
    stopOpacity: 0.81
  })), _stop30 || (_stop30 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9f1fd",
    stopOpacity: 0.53
  })), _stop31 || (_stop31 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c7eafe",
    stopOpacity: 0.3
  })), _stop32 || (_stop32 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#bae5fe",
    stopOpacity: 0.14
  })), _stop33 || (_stop33 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#b2e2ff",
    stopOpacity: 0.04
  })), _stop34 || (_stop34 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afe1ff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.38 52.5L174.81 17a75.51 75.51 0 00-75.49 0L37.74 52.5A75.73 75.73 0 000 117.88V189a75.73 75.73 0 0037.74 65.38l61.58 35.52a75.56 75.56 0 0075.49 0l61.57-35.55A75.73 75.73 0 00274.12 189v-71.12a75.71 75.71 0 00-37.74-65.38zM252 189a53.36 53.36 0 01-26.68 46.21l-61.58 35.55a53.27 53.27 0 01-53.36 0l-61.57-35.58A53.35 53.35 0 0122.13 189v-71.12a53.36 53.36 0 0126.68-46.21l61.57-35.55a53.27 53.27 0 0153.36 0l61.58 35.55A53.36 53.36 0 01252 117.88z",
    fill: "#009995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252 111v71.09a53.36 53.36 0 01-26.68 46.21l-61.58 35.55a53.27 53.27 0 01-53.36 0l-61.57-35.51a53.36 53.36 0 01-26.68-46.21V111a53.34 53.34 0 0126.68-46.17l61.57-35.55a53.27 53.27 0 0153.36 0l61.58 35.55A53.37 53.37 0 01252 111z",
    fill: "#009995"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.94 30.45v36.06l-.34-.2-9 5.19-60.2 34.75-34.72-20c.29-.38.6-.76.91-1.14a53.64 53.64 0 0114.24-12l32.8-18.9 5.29-3.05.15-.08 16-9.24 7.37-4.26a53.28 53.28 0 018.24-3.86l1.27-.45a53.89 53.89 0 0117.17-2.84c.23 0 .53 0 .82.02z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 106.58v-.2l-69.06-39.87V30.45a53.27 53.27 0 0125.8 7.13l1.46.84 11.8 6.79 12.4 7.19 1.51.87 6.44 3.73 28 16.15A53.51 53.51 0 01241 86.93z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 119.35v71.09a53.24 53.24 0 01-3.76 19.68L207 186.31v-79.73l34-19.65a53.45 53.45 0 0111 32.42z",
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94 226.38v52.95h-.89a53.62 53.62 0 01-26.68-7.15l-26.74-15.42-34.83-20.11a53.32 53.32 0 01-22.58-25.71l42.15-24.33 69.23 40z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.23 210.12a53.35 53.35 0 01-22.92 26.53l-5.31 3.06-9.69 5.59-16.48 9.51-1.17.68-15 8.64-5.29 3.06-8.69 5a53 53 0 01-24.12 7.08l-1.67.05v-52.94L207 186.51v-.2z",
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.21 186.51l.16.1-42.15 24.33a53.24 53.24 0 01-4.1-20.5v-71.09a52.22 52.22 0 01.35-6 53.18 53.18 0 0111.18-27.11l34.72 20-.16.1z",
    fill: "url(#".concat(_id6, ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id7, ")"),
    d: "M206.99 106.38v80.13l-69.05 39.87-.34.19-69.22-39.96-.17-.1v-80.13l.17-.1 69.22-39.97.34.2 69.05 39.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37 45.66l-24.69-14.25-22.59-13-14.29-8.3A75.64 75.64 0 00137.6 0h-.55a75.34 75.34 0 00-30.8 6.59 71.69 71.69 0 00-6.94 3.52L92.55 14l-.08.05L82 20.14l-1.18.68-6.82 3.9L68.34 28 46 40.91l-8.24 4.75-1.66 1c-.93.57-1.84 1.15-2.74 1.77A75.77 75.77 0 00.56 102v.11A73.42 73.42 0 000 111v71.09a75.71 75.71 0 0037.31 65.12l.43.25 10.61 6.13 18.47 10.66 15.25 8.8L92.22 279l1.62.94 5.47 3.16a75.61 75.61 0 0035.74 10.07h3.15a75.56 75.56 0 0032-7.66q2.33-1.12 4.58-2.43l5.27-3 11.73-6.79 19.27-11.12 6.75-3.9 7.48-4.31 4.22-2.44 6.84-4a75.58 75.58 0 0037.74-65.37V111a75.7 75.7 0 00-37.71-65.34zM252 182.13a53.41 53.41 0 01-26.68 46.21l-6.85 4-11.7 6.75L200 243l-36.26 20.94a53.08 53.08 0 01-4.62 2.38 53.31 53.31 0 01-48.75-2.38l-40.29-23.3-21.28-12.3c-1.5-.87-2.95-1.81-4.35-2.8a53.35 53.35 0 01-22.07-38.24c-.17-1.7-.26-3.43-.26-5.17V111a53.38 53.38 0 0122.32-43.35c.74-.54 1.49-1 2.25-1.53s1.4-.88 2.11-1.29l36.27-20.95L91.83 40l.71-.41 10.6-6.12.39-.23 6.84-3.94a53.15 53.15 0 0141.16-5.14 52 52 0 0112.21 5.14l11.51 6.64 34.16 19.73 15.9 9.18a53.36 53.36 0 0126.3 39.78A56.43 56.43 0 01252 111z",
    fill: "url(#".concat(_id8, ")")
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24.72l11.07 19.16L48.8 64.83c-.71.41-1.42.84-2.11 1.29s-1.51 1-2.25 1.53l-11.1-19.23c.9-.62 1.81-1.2 2.74-1.77l1.66-1zM211.07 262.11l-19.27 11.12-11.73 6.77-5.27 3q-2.25 1.31-4.58 2.43l-11.1-19.22q2.35-1.08 4.62-2.38L200 243z",
    fill: "#d9fffe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2fffe",
    d: "M92.47 14.07l11.06 19.16-.39.22-10.6 6.12-.71.41-11.06-19.16 1.18-.68 10.52-6.07zM229.52 251.46l-4.22 2.44-7.48 4.31-11.06-19.16 11.7-6.75 11.06 19.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.89 2.39l19.36 33.53-11.51-6.64a52 52 0 00-12.21-5.14L137.6 0a75.79 75.79 0 0118.29 2.39zM271.34 202.35a75.56 75.56 0 01-7.09 17l-13.91-24.1a53.25 53.25 0 001.66-13.12v-13.29z",
    fill: "#ffccf6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.12 182.13c0 1.74.09 3.47.26 5.17L0 148.54v-29.3l22.12 38.31zM92.22 279l-10.15-5.87-15.25-8.8-22.37-38.79q2.1 1.5 4.35 2.8l21.28 12.3z",
    fill: "#d9fffe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.92 91.33L139 65.45c0-2-.09-3.94-.13-5.92-.05-2.26-.17-4.52-.26-6.78s-.23-4.52-.41-6.78-.35-4.51-.6-6.77c-.25 2.26-.45 4.51-.6 6.77s-.28 4.52-.41 6.78-.21 4.52-.26 6.78c0 2-.11 4-.13 6-2.66 1.51-5.32 3-7.95 4.57-2.87 1.67-5.7 3.4-8.53 5.14-5.64 3.52-11.24 7.1-16.63 11 6.11-2.7 12-5.76 17.88-8.88 2.92-1.58 5.84-3.17 8.72-4.82 2.65-1.48 5.27-3 7.89-4.57zM95.17 91.12l-27.11 14c-1.73-1-3.48-1.9-5.21-2.86-2-1.09-4-2.11-6-3.17s-4-2.06-6.08-3-4.09-2-6.17-2.87c1.83 1.33 3.68 2.64 5.57 3.91s3.78 2.5 5.67 3.75 3.81 2.44 5.74 3.61c1.7 1 3.38 2.07 5.09 3.09 0 3-.07 6.11 0 9.16 0 3.32.09 6.64.18 10 .23 6.65.53 13.29 1.26 19.93.72-6.64 1-13.28 1.25-19.93.09-3.32.18-6.64.18-10v-9.13zM86.2 195.61c-2.83-1.73-5.67-3.47-8.54-5.13-2.61-1.56-5.27-3.06-7.92-4.56l-1.42-30.46L66.89 186c-1.7 1-3.39 2.06-5.08 3.08-1.93 1.17-3.83 2.41-5.74 3.61s-3.8 2.46-5.67 3.75-3.74 2.56-5.57 3.91c2.08-.92 4.14-1.87 6.17-2.87l6.08-3c2-1 4-2.08 6-3.17 1.74-1 3.49-1.89 5.22-2.86 2.63 1.55 5.26 3.11 7.93 4.59 2.87 1.66 5.79 3.24 8.71 4.83 5.87 3.12 11.77 6.18 17.89 8.87-5.39-4.02-10.99-7.6-16.63-11.13zM234.93 202.44l-26.54-16.9c0-2-.09-3.95-.13-5.93 0-2.26-.17-4.52-.26-6.78s-.23-4.52-.41-6.78-.35-4.52-.6-6.78q-.37 3.39-.6 6.78c-.18 2.26-.28 4.52-.41 6.78s-.21 4.52-.26 6.78c0 2-.11 4-.13 5.95-2.66 1.5-5.32 3-8 4.57-2.87 1.66-5.7 3.4-8.53 5.13-5.64 3.53-11.24 7.11-16.63 11.05 6.11-2.69 12-5.75 17.88-8.87 2.92-1.59 5.84-3.17 8.72-4.83 2.66-1.48 5.28-3 7.9-4.58z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.05 161.11l-26.54-16.89c0-2-.09-4-.13-5.94 0-2.26-.17-4.52-.26-6.78s-.23-4.52-.41-6.78-.35-4.52-.6-6.78q-.37 3.39-.6 6.78c-.18 2.26-.28 4.52-.41 6.78s-.21 4.52-.26 6.78c0 2-.11 4-.13 5.95-2.66 1.5-5.32 3-8 4.57-2.87 1.66-5.7 3.4-8.53 5.13C113.59 157.46 108 161 102.6 165c6.11-2.7 12-5.76 17.88-8.88 2.92-1.59 5.84-3.17 8.72-4.83 2.66-1.48 5.28-3 7.9-4.58z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218 47.18l8.19 4.14c1.37.69 2.72 1.35 4.08 2.14a46.27 46.27 0 014 2.37A67.14 67.14 0 01248.57 68a67.84 67.84 0 0117.17 42.83c0 1.56.1 3.16.05 4.67l-.11 4.58q-.15 6.09-.34 12.16a1.19 1.19 0 01-2.38 0q-.19-6.08-.34-12.16c-.07-3-.12-6.13-.3-9.07a66 66 0 00-1.19-8.85 70 70 0 00-28.52-43.74c-2.44-1.73-5-3.24-7.66-4.81l-7.88-4.69c-5.23-3.24-4.57-4.44.93-1.74zM9.53 182.26a1.18 1.18 0 012.35.16v.1a63.57 63.57 0 004 19.8 60.77 60.77 0 0010 17.26 71.23 71.23 0 007 7.22c2.66 2.35 5.3 4.72 7.89 7.15a1.19 1.19 0 01-1.46 1.86c-3-1.94-5.9-3.95-8.81-6a54.06 54.06 0 01-8.14-7.2 55.15 55.15 0 01-6.46-8.8 56.93 56.93 0 01-4.44-10 55.26 55.26 0 01-2.2-10.64 52.59 52.59 0 01.18-10.79z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.34,
    cy: 106.25,
    rx: 32.62,
    ry: 22.93,
    transform: "rotate(-71.77 68.337 106.252)",
    fill: "url(#".concat(_id9, ")")
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.61,
    cy: 66.32,
    rx: 22.93,
    ry: 32.62,
    transform: "rotate(-47.26 137.614 66.321)",
    fill: "url(#".concat(_id10, ")")
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.12,
    cy: 186.31,
    rx: 22.93,
    ry: 32.62,
    transform: "rotate(-30 207.117 186.317)",
    fill: "url(#".concat(_id11, ")")
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1591b8",
    d: "M151.72 97.58v99.87h-3.29v-95.92h-22.99v-3.95h26.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1bb8e3",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    },
    d: "M125.44 101.53h23v95.93h-23z"
  }));
}
export default SvgDiamond;